<template>
  <div>

    <h2 class="call-name">{{ title }} <small><code>/f13/{{ callName }}</code></small></h2>

    <div class="params">
      <div :class="{'form-group': true, row: true, 'has-danger': !params.perf_id}">
        <label for="perf-id" class="col-3 col-form-label">Performance ID</label>
        <div class="col-3">
          <input v-model="params.perf_id" type="text" class="form-control" id="perf-id">
        </div>
      </div>
      <div class="form-group row">
        <label for="add-seat-blocks" class="col-3">Add seat blocks</label>
        <div class="col-3">
          <div class="form-check">
            <label class="form-check-label">
              <input v-model="params.add_seat_blocks" type="checkbox" class="form-check-input" id="add-seat-blocks">
            </label>
          </div>
        </div>
      </div>
      <button @click="updateQueryFromParams()" type="button" class="btn btn-primary">Go</button>
    </div>

    <api-result :results="results" :response="response" :loading="loading">
      <h3>Ticket Types</h3>
      <ul class="ticket-types">
        <li v-for="ticketType in results">
          {{ ticketType.ticket_type_code }} == {{ ticketType.ticket_type_desc }}
          <ul class="price-bands">
            <li v-for="priceBand in ticketType.price_band">
              <p class="price-band-code">{{ priceBand.price_band_code}}
                <span v-if="priceBand.price_band_desc "> == {{ priceBand.price_band_desc }}</span>
                <router-link :to="{ name: 'discounts', query: { perf_id: params.perf_id, price_band_code: priceBand.price_band_code, ticket_type_code: ticketType.ticket_type_code }}" class="result-link">Discounts</router-link>
              </p>
              <p>Number available = {{ priceBand.number_available }}</p>
              <p>Seatprice = {{ formatPrice(priceBand.sale_seatprice) }}, Surcharge = {{ formatPrice(priceBand.sale_surcharge) }}</p>

              <div v-if="priceBand.free_seat_blocks" class="seats">
                <p>Seats:</p>
                <ul>
                  <li v-for="row in priceBand.free_seat_blocks.blocks_by_row">{{ row }}</li>
                </ul>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </api-result>

  </div>
</template>


<script>
import apiCallMixin from './ApiCallMixin'
import ApiResult from './ApiResult'
export default {
  name: 'availability',
  mixins: [apiCallMixin],
  components: { ApiResult },
  data () {
    return {
      title: 'Availability',
      callName: 'availability',
      params: {
        perf_id: '',
        add_seat_blocks: false
      }
    }
  },
  methods: {
    validateForm () {
      if (!this.params.perf_id) {
        return false
      }
      return true
    },
    parseResponse (response, success) {
      if (success) {
        this.results = []
        let ticketTypes = response.body['availability']['ticket_type']
        this.results = ticketTypes
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.results {
  .ticket-types > li {
    margin-bottom: 2rem;
  }
  ul.price-bands {
    margin-top: 0.5rem;
    p {
      font-size: 1rem;
    }
    > li {
      margin-bottom: 1rem;
      .price-band-code {
        font-size: 1.2rem;
      }
      p {
        margin-bottom: 0;
      }
    }
  }
  .seats {
    ul {
      margin-top: 0.5rem;
      li {
        font-size: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Availability.vue?f5c80316